import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './DateTimeInput.module.css';

interface DateInputProps {
  value: string; // YYYY-MM-DD
  onChange: (value: string) => void;
  required?: boolean;
  placeholder?: string;
}

const DateInput: React.FC<DateInputProps> = ({ value, onChange, required, placeholder }) => {
  const parsed = value ? new Date(value + 'T00:00:00') : null;

  const handleChange = (date: Date | null) => {
    if (!date) { onChange(''); return; }
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    onChange(`${y}-${m}-${d}`);
  };

  return (
    <div className={styles.wrapper}>
      <DatePicker
        selected={parsed}
        onChange={handleChange}
        dateFormat="dd/MM/yyyy"
        locale="pt-BR"
        placeholderText={placeholder || 'dd/mm/aaaa'}
        required={required}
        className={styles.input}
        calendarClassName={styles.calendar}
        wrapperClassName={styles.pickerWrapper}
      />
    </div>
  );
};

export default DateInput;
